import { dataHooks } from '@wix/data-hooks';

export const leaveSessionModalDataHooks = dataHooks<{
  main;
}>('LeaveSessionModal');
